module.exports = __webpack_public_path__ + "static/media/cfac06.39ed3cf0.jpg";